import UseScrollAnimation from "../Elements/ScrollAnimation";
// import ThreeTestimonials from "./Page_Sections/threeTestimonials";
// import AboutThePractitioner from "./Page_Sections/aboutThePractitioner";

const sections = [
  {
    h: "Not a Substitute for Medical Care",
    p: "The information and services provided by The Wellness Destination Homeopathy, LLC are intended to support overall wellness. They are not a substitute for medical diagnosis, treatment, or emergency care.",
  },
  {
    h: "Always Consult Your Physician",
    p: "Always seek the advice of your physician or qualified health provider with any questions you may have regarding a medical condition. Never disregard professional medical advice or delay seeking it because of information received here.",
  },
  {
    h: "Individual Results May Vary",
    p: "Homeopathic care is highly individualized. Results vary from person to person, and no specific outcomes can be guaranteed.",
  },
  {
    h: "Emergencies",
    p: "If you believe you are experiencing a medical emergency, please call your local emergency services immediately. Do not contact this practice for emergency medical care.",
  },
  {
    h: "Website Information",
    p: "Information on this website is provided for educational purposes only and does not establish a practitioner-client relationship. That relationship begins only after a formal consultation has taken place.",
  },
  {
    h: "External Links",
    p: "Links to third-party websites are provided for convenience. We are not responsible for the content, accuracy, or privacy practices of any external sites.",
  },
];

const Disclaimer = () => {
  UseScrollAnimation(); // ✅ just call it

  return (
    <>
      <div className="HomeParent">
        <div className="HomeBox ">
          <section className="Disclaimer_Section">
            <div className="Disclaimer_SectionBox">
              <div className="Disclaimer_Section_TitleHeadingContent">
                <p className="Disclaimer_Section_Title animate-top">
                  Disclaimer
                </p>
                <span className="Disclaimer_Section_Heading animate-top">
                  Important to know.
                </span>
                <p className="Disclaimer_Section_Content animate-top">
                  Please read carefully before using this website or our
                  services.
                </p>
              </div>
            </div>
          </section>

          <section className="Disclaimer_Section00">
            <div className="Disclaimer_SectionParent00">
              {sections.map((s) => (
                <div className="Disclaimer_SectionBox00">
                  <h2 className="Disclaimer_Section_Heading00 animate-top">
                    {s.h}
                  </h2>
                  <p className="Disclaimer_Section_Content00 animate-top">
                    {s.p}
                  </p>
                </div>
              ))}
            </div>
          </section>
          {/* <ThreeTestimonials /> */}

          {/* <AboutThePractitioner /> */}
        </div>
      </div>
    </>
  );
};

export default Disclaimer;
